// extracted by mini-css-extract-plugin
export default {"wrapper":"PremiumIntro_wrapper__oVufp","buttonsWrapper":"PremiumIntro_buttonsWrapper__5sHWa"};